import { ContainerModule } from 'inversify';
import { FinsightSocketProcessingAdapter, MultipartUploadStrategy, UploadDispatcher, MultipartUploadAdapter } from '@dealroadshow/file-uploader';
import { type ISocketClient } from '@finsight/socket-client';
import SocketDITypes from '@finsight/socket-client/DITypes';
import DITypes from './types';
import type { IUploadDispatcher } from './interfaces';
import UploadAdapter from '../UploadAdapter';

export const FileUploadModule = new ContainerModule(({ bind }) => {
  bind(DITypes.SocketProcessingAdapter)
    .toDynamicValue(({ get }) => {
      const socketClient = get<ISocketClient>(SocketDITypes.SocketClient);
      return new FinsightSocketProcessingAdapter(socketClient);
    })
    .inSingletonScope();

  bind<MultipartUploadAdapter>(DITypes.UploadAdapter).to(UploadAdapter).inSingletonScope();

  bind<IUploadDispatcher>(DITypes.UploadDispatcher)
    .toDynamicValue(({ get }) => {
      const processingAdapter = get<FinsightSocketProcessingAdapter>(DITypes.SocketProcessingAdapter);
      const uploadAdapter = get<MultipartUploadAdapter>(DITypes.UploadAdapter);
      return new UploadDispatcher(new MultipartUploadStrategy(uploadAdapter, processingAdapter));
    })
    .inSingletonScope();
});
